import { aClave } from './texto';
import { resolverCuadroGuardado, type CuadroGuardado } from './vistaCuadro';
import { conTabla, type GrupoGuardado } from './vistaGrupos';
import type { Lado } from './cuadro';
import type { PartidoProgramado, PartidoARepartir } from './programacion';

interface CategoriaRecursos {
  parejas: { id: number; jugador1: string; jugador2: string; estado: 'inscripta' | 'baja' }[];
  grupos: GrupoGuardado[]; cuadro: CuadroGuardado | null; pasan_por_grupo: number | null;
}
/** Considera todos los posibles participantes cuando todavía no hay clasificados. */
export function recursosDePartidos(categorias: readonly CategoriaRecursos[]): Map<number, PartidoProgramado & PartidoARepartir> {
  const salida = new Map<number, PartidoProgramado & PartidoARepartir>();
  for (const c of categorias) {
    const bajas = new Set(c.parejas.filter(p => p.estado === 'baja').map(p => p.id));
    const jugadores = (ids: number[]) => [...new Set(ids.flatMap(id => {
      const p = c.parejas.find(x => x.id === id);
      return p ? [aClave(p.jugador1), aClave(p.jugador2)] : [];
    }))];
    const grupoIds: number[] = [];
    for (const g of c.grupos) {
      const vista = conTabla(g, bajas, c.pasan_por_grupo ?? 1);
      for (const p of g.partidos) {
        const ids = [p.pareja_a, p.pareja_b].filter((id): id is number => id !== null);
        salida.set(p.id, { ...p, parejas: ids, jugadores: jugadores(ids), jugado: p.estado === 'jugado' || Boolean(vista.resultados.get(p.id)?.porAbandono), despuesDe: [] });
        grupoIds.push(p.id);
      }
    }
    if (!c.cuadro) continue;
    const cuadro = resolverCuadroGuardado(c.cuadro, c.grupos, bajas, c.pasan_por_grupo ?? 1);
    const posibles = (lado: Lado): number[] => {
      if ('pareja' in lado) return [lado.pareja];
      if ('libre' in lado) return [];
      if (lado.espera.tipo === 'grupo') return c.grupos.find(g => g.id === (lado.espera as {grupo: number}).grupo)?.parejas.filter(id => !bajas.has(id)) ?? [];
      const previo = cuadro.rondas[lado.espera.ronda - 1]?.[lado.espera.pos];
      return previo ? [...new Set([...posibles(previo.a), ...posibles(previo.b)])] : [];
    };
    cuadro.rondas.forEach((ronda, i) => ronda.forEach(x => {
      if (x.pasaDirecto) return;
      const p = c.cuadro!.partidos.find(p => p.id === x.id);
      if (!p) return;
      const ids = [...new Set([...posibles(x.a), ...posibles(x.b)])];
      salida.set(x.id, { ...p, parejas: ids, jugadores: jugadores(ids), jugado: p.estado === 'jugado' || x.porAbandono, despuesDe: i === 0 ? grupoIds : [cuadro.rondas[i - 1]![x.pos * 2]!.id, cuadro.rondas[i - 1]![x.pos * 2 + 1]!.id] });
    }));
  }
  return salida;
}
